// Rows per page on the client page's list cards: Work we owe them, Conversations and
// What they asked us for. One number so the three pagers turn over together.
export const CARD_PAGE_SIZE = 10;
